import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeColorScheme } from '../../models/theme.model';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      (click)="toggleTheme()"
      class="relative inline-flex items-center justify-center p-2 rounded-lg hover:bg-accent transition-colors duration-200"
      [attr.aria-label]="
        isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'
      ">
      <!-- Sun Icon (Light Mode) -->
      <svg
        *ngIf="!isDarkMode"
        class="w-5 h-5 text-foreground"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>

      <!-- Moon Icon (Dark Mode) -->
      <svg
        *ngIf="isDarkMode"
        class="w-5 h-5 text-foreground"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
      </svg>
    </button>
  `,
  styles: [],
})
export class ThemeToggleComponent implements OnInit {
  isDarkMode = false;
  @Output() themeChange = new EventEmitter<boolean>();

  ngOnInit() {
    this.loadTheme();
  }

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    this.applyTheme();
    this.themeChange.emit(this.isDarkMode);
  }

  private loadTheme() {
    const savedTheme = JSON.parse(localStorage.getItem('theme') || 'null');
    if (savedTheme) {
      this.isDarkMode = savedTheme.colorScheme === ThemeColorScheme.DARK;
    } else {
      this.isDarkMode = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
    }
    this.applyTheme();
  }

  private applyTheme() {
    const htmlElement = document.documentElement;
    if (this.isDarkMode) {
      htmlElement.classList.add('dark');
      // localStorage.setItem('theme', 'dark');
    } else {
      htmlElement.classList.remove('dark');
      // localStorage.setItem('theme', 'light');
    }
  }
}
